<template>
  <a-modal
    :open="isVisible"
    title="Выберите пользователя"
    centered
    ok-text="Подтвердить"
    cancel-text="Отмена"
    :confirm-loading="isLoading"
    @ok="handleChangeCutter"
    @cancel="close">
    <a-select
      v-model:value="newCutterId"
      :filter-option="filterName"
      show-search
      :style="{ width: '100%' }">
      <a-select-option
        v-for="(user) in simpleUsersList"
        :key="user.id"
        :value="user.id">
        {{ user.name }}
      </a-select-option>
    </a-select>
  </a-modal>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { sortBy } from 'lodash';
import { searchForSimpleUsersListSelect } from '@/utils/searchForSimpleUsersListSelect';

const props = defineProps({
  planId: {
    default: () => null,
    type: Number,
  },
  action: {
    default: () => 'crm/changeCrmPlanCutter3d',
    type: String,
  },
});

const emit = defineEmits(['changeCutterSuccess']);

const store = useStore();

store.dispatch('crm/getSimpleUsersList');

const newCutterId = ref(null);

const simpleUsersList = computed(() => sortBy(store.state.crm.simpleUsersList, ['name']));

const filterName = (input, option) => searchForSimpleUsersListSelect(simpleUsersList, input, option);

const isVisible = computed(() => store.state.crm.modals.changeCutter.isVisible);
const isLoading = computed(() => store.state.crm.modals.changeCutter.isLoading);
const close = () => store.commit('crm/setChangeCutterModalVisibility', false);

const handleChangeCutter = async () => {
  await store.dispatch(props.action, { id: props.planId, cutterId: newCutterId.value });
  emit('changeCutterSuccess');
};
</script>

<style scoped>

</style>
